export const PASSWORD_TOOL_TIP = `
- At least 8 characters\n
- At least one uppercase letter (A-Z)\n
- At least one lowercase letter (a-z)\n
- At least one number (0-9)\n
- Can include any symbols (e.g., !@#$%^&*)
`;
